import React, { useState } from "react";
import {
    Dialog,
    DialogContent,
    IconButton,
    Typography,
    Box,
    CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const OptionPopup = ({
    open,
    onClose,
    product,
    onSelectOption
}) => {
    const [selectedIndex, setSelectedIndex] = useState(null);

    const handleOptionClick = (index) => {
        setSelectedIndex(index);
        if (onSelectOption) {
            onSelectOption(product.options.product_options[index]);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: { borderRadius: "20px", overflow: "hidden" },
            }}
            BackdropProps={{ sx: { backdropFilter: "blur(6px)" } }}
        >
            <IconButton
                onClick={onClose}
                sx={{ position: "absolute", right: 12, top: 12, zIndex: 10 }}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent sx={{ padding: 0, textAlign: "center", position: "relative" }}>
                {!product ? (
                    <Box
                        sx={{
                            width: "100%",
                            height: 250,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        <Box sx={{ width: "100%", height: 250, overflow: "hidden" }}>
                            <img
                                src={product.images[0]}
                                alt={product.name}
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                        </Box>

                        <Typography
                            sx={{
                                mt: 2,
                                mb: 2,
                                fontWeight: 600,
                                fontSize: { xs: "14px", md: "24px" },
                            }}
                        >
                            {product.name}
                        </Typography>

                        <Box sx={{ px: 3, pb: 3 }}>
                            <Typography
                                sx={{ fontSize: "16px", mb: 1, fontWeight: 500, textAlign: "left" }}
                            >
                                Choose an Option
                            </Typography>

                            {product.options?.product_options?.length > 0 ? (
                                product.options.product_options.map((option, index) => (
                                    <Box
                                        key={index}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleOptionClick(index);
                                        }}
                                        sx={{
                                            p: 2,
                                            border: "1px solid #ddd",
                                            borderRadius: "10px",
                                            mb: 1.5,
                                            textAlign: "left",
                                            cursor: "pointer",
                                            backgroundColor: selectedIndex === index ? "#E50218" : "white",
                                            color: selectedIndex === index ? "white" : "black",
                                            transition: "0.2s",
                                            "&:hover": {
                                                borderColor: "#E50218",
                                            },
                                        }}
                                    >
                                        <Typography sx={{ fontWeight: 500 }}>{option.label}</Typography>
                                    </Box>
                                ))
                            ) : (
                                <Typography sx={{ color: "gray" }}>
                                    No configurable options for this product.
                                </Typography>
                            )}
                        </Box>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default OptionPopup;
